import React, { useState, useEffect } from 'react'
import { useLocation, Link } from 'react-router-dom'
import { fetchMe } from '../../api/index'
import styles from './NavBar.module.css'

const SIDEBAR_WIDTH = '260px'
const SIDEBAR_COLLAPSED = '72px'

const IconDashboard = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="9" rx="1" />
    <rect x="14" y="3" width="7" height="5" rx="1" />
    <rect x="14" y="12" width="7" height="9" rx="1" />
    <rect x="3" y="16" width="7" height="5" rx="1" />
  </svg>
)

const IconImport = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
)

const IconInvoices = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
  </svg>
)

const IconCoaches = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
)

const IconUsers = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
)

const IconSettings = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
)

const IconChevron = ({ collapsed }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ transform: collapsed ? 'rotate(180deg)' : 'none', transition: 'transform 0.28s' }}
  >
    <polyline points="15 18 9 12 15 6" />
  </svg>
)

const NavItem = ({ to, label, icon, active, title }) => (
  <Link
    to={to}
    className={`${styles.navLink} ${active ? styles.navLinkActive : ''}`}
    title={title || label}
    aria-current={active ? 'page' : undefined}
  >
    <span className={styles.iconWrap}>{icon}</span>
    <span className={styles.linkLabel}>{label}</span>
  </Link>
)

const NavBar = () => {
  const location = useLocation()
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem('sidebarCollapsed') === 'true'
  )

  useEffect(() => {
    const profile = JSON.parse(localStorage.getItem('profile'))
    setUser(profile)

    if (!profile?.token) return

    fetchMe()
      .then(({ data }) => {
        const updated = { ...profile, result: { ...profile.result, ...data } }
        localStorage.setItem('profile', JSON.stringify(updated))
        setUser(updated)
      })
      .catch(() => {})
  }, [location])

  useEffect(() => {
    const width = collapsed ? SIDEBAR_COLLAPSED : SIDEBAR_WIDTH
    document.documentElement.style.setProperty('--sidebar-width', width)
    localStorage.setItem('sidebarCollapsed', collapsed)
  }, [collapsed])

  if (!user) return null

  const admin = user?.result?.role === 'admin'
  const corporate = user?.result?.role === 'corporate'
  const path = location.pathname
  const homePath = corporate ? '/corporate/dashboard' : '/dashboard'

  const isActive = (matchPath) => {
    if (matchPath === '/import') {
      return path === '/import' || path.startsWith('/campagnes/')
    }
    if (matchPath === '/corporate/import') {
      return path === '/corporate/import' || path.startsWith('/corporate/campagnes/')
    }
    if (matchPath === '/coaches') {
      return path === '/coaches' || path.startsWith('/coaches/')
    }
    return path === matchPath || path.startsWith(`${matchPath}/`)
  }

  const userName = user?.result?.name || 'Utilisateur'
  const initial = userName.charAt(0).toUpperCase()

  return (
    <aside
      className={`${styles.sidebar} ${collapsed ? styles.collapsed : ''}`}
      aria-label="Navigation principale"
    >
      <div className={styles.brand}>
        <Link to={homePath} className={styles.brandLink}>
          <div className={`${styles.logoWrap} ${collapsed ? styles.logoWrapCollapsed : styles.logoWrapExpanded}`}>
            <img
              src={collapsed ? '/favicon.png' : '/cg-logo-sidebar.png'}
              alt="California Gym"
            />
          </div>
        </Link>
        <button
          type="button"
          className={styles.collapseBtn}
          onClick={() => setCollapsed((c) => !c)}
          aria-label={collapsed ? 'Développer le menu' : 'Réduire le menu'}
        >
          <IconChevron collapsed={collapsed} />
        </button>
      </div>

      <nav className={styles.nav}>
        {corporate ? (
          <>
            <div className={styles.sectionLabel}>Corporate</div>
            <NavItem to="/corporate/dashboard" label="Dashboard" icon={<IconDashboard />} active={isActive('/corporate/dashboard')} />
            <NavItem to="/corporate/import" label="Envoi PDF" icon={<IconImport />} active={isActive('/corporate/import')} />
            <NavItem to="/corporate/clients" label="Clients convention" icon={<IconCoaches />} active={isActive('/corporate/clients')} />
          </>
        ) : (
          <>
            <div className={styles.sectionLabel}>Principal</div>
            <NavItem to="/dashboard" label="Dashboard" icon={<IconDashboard />} active={isActive('/dashboard')} />
            <NavItem to="/import" label="Import mensuel" icon={<IconImport />} active={isActive('/import')} />
            <NavItem to="/invoices" label="Factures" icon={<IconInvoices />} active={isActive('/invoices')} />
            <NavItem to="/coaches" label="Coachs" icon={<IconCoaches />} active={isActive('/coaches')} />
          </>
        )}

        {admin && !corporate && (
          <>
            <div className={styles.sectionLabel}>Corporate</div>
            <NavItem to="/corporate/dashboard" label="Dashboard Corp." icon={<IconDashboard />} active={isActive('/corporate/dashboard')} />
            <NavItem to="/corporate/import" label="Envoi PDF" icon={<IconImport />} active={isActive('/corporate/import')} />
            <NavItem to="/corporate/clients" label="Clients convention" icon={<IconCoaches />} active={isActive('/corporate/clients')} />
          </>
        )}

        {admin && (
          <>
            <div className={styles.sectionLabel}>Administration</div>
            <NavItem to="/admin/users" label="Utilisateurs" icon={<IconUsers />} active={isActive('/admin/users')} />
          </>
        )}

        <div className={styles.sectionLabel}>Système</div>
        <NavItem to="/settings" label="Paramètres" icon={<IconSettings />} active={isActive('/settings')} />
      </nav>

      <div className={styles.footer}>
        <div className={styles.userCard}>
          <div className={styles.avatar} aria-hidden="true">{initial}</div>
          <div className={styles.userInfo}>
            <span className={styles.userName}>{userName}</span>
            <span className={`${styles.userRole} ${admin ? '' : styles.userRoleUser}`}>
              {admin ? 'Administrateur' : corporate ? 'Corporate' : 'Utilisateur RH'}
            </span>
          </div>
        </div>
      </div>
    </aside>
  )
}

export default NavBar
